<div class="row align-items-end">
  <div class="col-sm-6 text-center" *ngIf="!isGettingTracto">
    <div>
      <small id="tracto-dates" class="text-muted">
        Creado: {{ tracto.createdAt | dateFormat | dateWithoutSeconds }} <br />
        Actualizado: {{ tracto.updatedAt | dateFormat | dateWithoutSeconds }}
      </small>
    </div>
    <div class="divCenter gap-12">
      <button
        id="tracto-details-reject"
        type="button"
        class="btn btn-outline-danger-new my-2"
        (click)="onRejectTracto()"
        *ngIf="tractoCanBeRejected && showButton('reject')"
      >
        Rechazar
      </button>
      <button
        id="tracto-details-approve"
        type="button"
        class="btn btn-outline-primary-new my-2"
        (click)="onApproveTracto()"
        *ngIf="tractoNeedsApproval && showButton('approve')"
      >
        Aprobar
      </button>
    </div>
  </div>
  <div class="col-sm-6 text-end">
    <div class="btn-group" style="padding-top: 60px">
      <div ngbDropdown class="d-inline-block">
        <button
          type="button"
          class="btn btn-outline-primary dropdownButton mx-2 dropdownButton-new"
          id="tracto-details-actions"
          *ngIf="!isGettingTracto && showButton('actions')"
          ngbDropdownToggle
        >
          Acciones
          <span class="material-symbols-outlined"> keyboard_arrow_down </span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownActions">
          <a
            id="tracto-details-edit"
            *ngIf="!isGettingTracto && showButton('edit')"
            (click)="onEditTracto()"
            class="dropdown-item"
            ngbDropdownItem
          >
            Actualizar documentos</a
          >
          <a
            id="tracto-details-reprocesing"
            *ngIf="!isGettingTracto && isAdmin"
            [disabled]="!isReprocesingAvailable()"
            (click)="OnReprocesiing()"
            class="dropdown-item"
            ngbDropdownItem
            >Reprocesar</a
          >
          <div class="dropdown-divider"></div>
          <a
            id="tracto-details-archive"
            *ngIf="!isGettingTracto && showButton('archive')"
            (click)="onArchiveTracto()"
            ngbDropdownItem
          >
            Archivar</a
          >
          <a
            id="tracto-details-delete"
            *ngIf="!isGettingTracto && showButton('delete')"
            (click)="onDeleteTracto()"
            ngbDropdownItem
          >
            Borrar</a
          >
        </div>
      </div>
      <button
        id="tracto-details-refresh"
        class="btn-refresh-details"
        *ngIf="!isGettingTracto"
        (click)="onRefreshTracto()"
      >
        <span class="material-symbols-outlined"> refresh </span>
      </button>
    </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-sm-6 text-center my-5" *ngIf="isGettingTracto">
    <app-spinner message="Cargando detalles del vehículo..."></app-spinner>
  </div>
  <div
    class="col-sm-6 box-details-cab"
    [ngStyle]="{ border: '3px solid ' + getColor() }"
    *ngIf="!isGettingTracto"
  >
    <div class="div-box-sap-id">
      <h4 [ngStyle]="{ color: getColor(), 'font-weight': 'bold' }">
        SAP ID: {{ tracto.sapId! | sapId }}
      </h4>
    </div>
    <div style="display: inline">
      <p><strong>Transportista</strong>: <br />{{ tracto.carrier!.name }}</p>
      <p><strong>Patente</strong>: <br />{{ tracto.licensePlate }}</p>
      <p>
        <strong>Acoplamiento</strong>: <br />
        <span *ngIf="tractoIsCoupled"
          >{{ coupleType }} {{ coupleIdentification }}</span
        >
        <span *ngIf="!tractoIsCoupled">Desacoplado</span>
      </p>
    </div>
    <div class="divCenter" style="text-align: center">
      <p *ngIf="showBlockingMotives">
        <strong
          >Bloqueado el
          {{
            tracto.lastStatusInformedAt || tracto.updatedAt
              | dateFormat
              | dateWithoutSeconds
          }}
          por</strong
        >:<br />
        <span
          class="badge border rounded-4 text-bg-light mx-1"
          *ngFor="let motive of tracto.blockingMotives"
        >
          {{ motive }}
        </span>
      </p>
    </div>

    <div class="divCenter">
      <h5>
        <span
          class="badge"
          [ngStyle]="{ 'background-color': getColor() }"
          style="width: 200px; border-radius: 60px"
        >
          <span>
            <img
              [src]="getImageSrc(tracto.status)"
              height="25"
              width="25"
              alt="Estado"
            />
          </span>
          {{ tracto.status | master : "VEHICLES#STATUSES" }}</span
        >
      </h5>
      <div *ngIf="hasComment">
        <label
          class="custom-file-upload pt-2 mx-1 float-end text-secondary"
          style="cursor: pointer"
        >
          <a id="entity-comment" title="Comentario" (click)="onViewComment()">
            <span class="material-symbols-outlined">comment</span>
          </a>
        </label>
      </div>
    </div>
    <div class="divCenter mb-2" *ngIf="hasComment && showComment">
      <div class="collapse comment" [ngClass]="showCommentClass()">
        <div class="card card-body">
          {{ tracto.comment }}
        </div>
      </div>
    </div>

    <div class="divCenter">
      <h6>
        <span
          class="badge border rounded-4 text-bg-light"
          *ngIf="hasToExpireDocuments()"
        >
          <span class="badge border rounded-circle text-bg-light">{{
            tracto.documentsToExpire
          }}</span>
          por vencer</span
        >
      </h6>
      <h6>
        <span
          class="badge border rounded-4 text-bg-light"
          *ngIf="hasExpiredDocuments()"
        >
          <span class="badge border rounded-circle text-bg-light">{{
            tracto.documentsExpired
          }}</span>
          vencido</span
        >
      </h6>
    </div>

    <div ngbAccordion style="padding: 10px">
      <div ngbAccordionItem [collapsed]="true">
        <h2 ngbAccordionHeader>
          <button id="tracto-details-accordion" ngbAccordionButton>
            Ver detalles
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody class="table-container">
            <ng-template>
              <table class="table table-hover">
                <caption>
                  Detalles del Vehículo
                </caption>
                <tbody>
                  <tr>
                    <th scope="row">Centro</th>
                    <td>{{ tracto.originalCenter! | master : "CENTERS" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Marca</th>
                    <td>{{ tracto.brand | master : "VEHICLES#BRANDS" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Modelo</th>
                    <td>{{ tracto.model }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Año de Fabricación</th>
                    <td>{{ tracto.year }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Antigüedad</th>
                    <td
                      [ngClass]="getTractoAgeClass(currentYear - tracto.year)"
                    >
                      {{ currentYear - tracto.year }} año{{
                        currentYear - tracto.year === 1 ? "" : "s"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Color</th>
                    <td>{{ tracto.color | master : "VEHICLES#COLORS" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Tipo</th>
                    <td>{{ tracto.type | master : "TRACTOS#TYPES" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Motor</th>
                    <td>
                      {{ tracto.engineType! | master : "TRACTOS#ENGINE_TYPES" }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Capacidad</th>
                    <td>
                      {{ tracto.capacity | master : "TRACTOS#CAPACITIES" }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Usado en Minería</th>
                    <td>{{ tracto.forMining ? "Sí" : "No" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Acreditación Ranchera</th>
                    <td>{{ tracto.hasRanchAccreditation ? "Sí" : "No" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Es Spot</th>
                    <td>{{ tracto.isSpot ? "Sí" : "No" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">GPS IMEI</th>
                    <td>{{ tracto.gpsImei }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Cámara IMEI</th>
                    <td>{{ tracto.cameraImei }}</td>
                  </tr>

                  <ng-container *ngIf="business === 'FUELS'">
                    <tr>
                      <th scope="row">Tipo de Acople</th>
                      <td>{{ tracto.coupleType }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Marcación conductor</th>
                      <td>{{ tracto.driverAssociationWay }}</td>
                    </tr>
                  </ng-container>

                  <tr>
                    <th class="align-middle" scope="row">Centro de Apoyo</th>
                    <td>
                      <div>
                        <label
                          *ngIf="showButton('edit-center')"
                          class="float-start me-1"
                          style="cursor: pointer"
                        >
                          <a
                            id="update-center"
                            title="Actualizar Centro de Apoyo"
                            (click)="onUpdateTracto()"
                          >
                            <span
                              class="material-symbols-outlined text-secondary"
                              >edit_square</span
                            >
                          </a>
                        </label>
                        {{ tracto.center | master : "CENTERS" }}
                      </div>
                    </td>
                  </tr>

                  <tr *ngIf="tracto.uses && tracto.uses.length > 0">
                    <th class="align-middle" scope="row">Usos del vehiculo</th>
                    <td>
                      <div class="flex">
                        <label
                          *ngIf="showButton('edit-uses')"
                          class="float-start me-1"
                          style="cursor: pointer"
                        >
                          <a
                            id="update-center"
                            title="Actualizar Centro de Apoyo"
                            (click)="onUpdateTractoUses()"
                          >
                            <span
                              class="material-symbols-outlined text-secondary"
                              >edit_square</span
                            >
                          </a>
                        </label>
                        <ng-container *ngFor="let use of tracto.uses">
                          <span class="selected-chip">
                            {{ use }}
                          </span>
                        </ng-container>
                      </div>
                    </td>
                  </tr>

                  <tr *ngIf="tracto.archiveId">
                    <th scope="row">Archivo</th>
                    <td>
                      <label
                        class="custom-file-upload pt-2 mx-1"
                        style="cursor: pointer"
                      >
                        <a
                          id="archive-tracto-details"
                          title="Visualizar Detalle"
                          (click)="onViewArchiveDetails()"
                        >
                          <span class="material-symbols-outlined text-secondary"
                            >docs</span
                          >
                        </a>
                      </label>
                      <label
                        class="custom-file-upload pt-2 mx-1"
                        style="cursor: pointer"
                        *ngIf="hasDocumentOnArchive()"
                      >
                        <a
                          id="preview-archive-tracto-docs"
                          title="Visualizar Documento"
                          (click)="onViewDocumentArchive()"
                        >
                          <span class="material-symbols-outlined text-secondary"
                            >preview</span
                          >
                        </a>
                      </label>
                      <label
                        class="custom-file-upload pt-2 mx-1"
                        style="cursor: pointer"
                        *ngIf="hasDocumentOnArchive()"
                      >
                        <a
                          id="download-archive-tracto-docs"
                          title="Descargar Documento"
                          (click)="onDownloadArchiveDocument()"
                        >
                          <span class="material-symbols-outlined text-secondary"
                            >download</span
                          >
                        </a>
                      </label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-6">
    <app-documents></app-documents>
  </div>
</div>

<!-- Modals -->
<ng-template #tractoModal let-c="close" let-d="dismiss">
  <app-modal-with-comment
    [modalTitle]="modalTitle"
    [modalQuestion]="modalQuestion"
    [modalMessage]="modalMessage"
    [showCommentForm]="modalWithComment"
    [mandatoryComment]="isBeingRejected"
    [commentForm]="commentForm"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  ></app-modal-with-comment>
</ng-template>

<!-- Update Attribute Modal -->
<ng-template #updateTractoAttributeModal let-c="close" let-d="dismiss">
  <app-modal-change-attributes
    [modalTitle]="modalTitle"
    [modalQuestion]="modalQuestion"
    [modalMessage]="modalMessage"
    [attributeForm]="updateAttributeForm"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  ></app-modal-change-attributes>
</ng-template>
<!-- Update Attribute Modal -->
<ng-template #updateTractoAttributeUsesModal let-c="close" let-d="dismiss">
  <app-modal-change-uses
    [modalTitle]="modalTitle"
    [modalQuestion]="modalQuestion"
    [modalMessage]="modalMessage"
    [entityName]="'TRACTOS'"
    [attributeForm]="updateAttributeForm"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  ></app-modal-change-uses>
</ng-template>

<!-- Archive Modal -->
<ng-template #archiveTractoModal let-c="close" let-d="dismiss">
  <app-modal-for-archiving
    [modalTitle]="modalTitle"
    [modalQuestion]="modalQuestion"
    [modalMessage]="modalMessage"
    [archiveForm]="archiveForm"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  ></app-modal-for-archiving>
</ng-template>

<!--Archive Details Modal-->
<ng-template #ArchiveTractoDetailsModal let-c="close" let-d="dismiss">
  <app-modal-details
    [archive]="tractoArchive?.entity"
    [updatedAt]="tractoArchive?.updatedAt"
    [comment]="tractoArchive?.comment"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  >
  </app-modal-details>
</ng-template>

<!--Document Viewer Modal-->
<ng-template #ArchiveTractodocumentViewer let-c="close" let-d="dismiss">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">{{ modalTitle }}</h4>
        <button
          id="document-item-modal-cross"
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="d('Cross')"
        ></button>
      </div>
      <div class="modal-body">
        <div class="text-center my-5" *ngIf="isGettingURL">
          <app-spinner message="Generando Vista Previa"></app-spinner>
        </div>
        <pdf-viewer
          [src]="pdfSource"
          [render-text]="true"
          [original-size]="false"
          [fit-to-page]="true"
          (page-rendered)="pageRendered()"
          style="width: 800px; height: 70vh"
        >
        </pdf-viewer>
      </div>
      <div class="modal-footer" *ngIf="!isGettingURL">
        <button
          id="document-item-modal-accept"
          type="button"
          class="btn btn-outline-primary"
          (click)="c('Accept')"
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
</ng-template>
